import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Stanoviste = {
	name: NAME,
	apiProvider,
	router,
};
